import { useState } from 'react';
import * as TY from 'containers/pages/contacts/constants';

const useFullAddressField = (type, contact, dispatch) => {
	const [openMap, setOpenMap] = useState(false);

	function onReset() {
		return dispatch({
			type:
				type === TY.ADDRESS_WORK
					? TY.ADDRESS_WORK_RESET
					: type === TY.ADDRESS_HOME
					? TY.ADDRESS_HOME_RESET
					: TY.ADDRESS_OTHER_RESET,
			payload: {
				address_id: contact[type].address_id,
				type: '',
				street: '',
				city: '',
				province: '',
				country: '',
				postalCode: '',
				placeId: '',
				coordinate: { lat: '', lng: '' },
				unit: '',
				fullAddress: '',
			},
		});
	}

	function onOpenMap() {
		setOpenMap(true);
	}

	function onCloseMap() {
		setOpenMap(false);
	}

	return { openMap, onReset, onOpenMap, onCloseMap };
};

export default useFullAddressField;
